import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Row } from "reactstrap";
import { connect } from 'react-redux';
import * as actionsRedux from '../Store/Actions/index';
import CardHoc from '../Hoc/cardHoc';
import { axiosApi } from '../Basicos/axiosInstances';
import { DateForm, SelectForm, Tabela, TableWithVirtualizedRow } from '../Basicos';
import { dateToPtBr, formatLaravelDate, parseDate } from '../Basicos/funcoes';
import MenuTable from '../Menu/menuTable';
import ModalGerenciamentoProva from '../Modal/ModalGerenciamentoProvas';

function montarColunas({ editar }, openModal) {
    let campos2 = [
        { label: 'Tipo de Atividade', name: 'aula.tipo_de_atividade.nome' },
        { label: 'Título da Prova', name: 'titulo' },
        { label: 'Data Prova', name: 'data_prova' },
    ]

    const colunas = campos2.map((elemento) => {
        switch (elemento.name) {
            case "cor":
                return {
                    Header: elemento.label,
                    Cell: ({ row }) => (
                        <div style={{ background: row.original.cor, width: -1, height: 32, borderRadius: 100 }} />)
                };
            default:
                return {
                    Header: elemento.label,
                    accessor: elemento.name,
                }
        }
    });

    if (editar) {
        colunas.push({
            Cell: ({ row }) => (
                <MenuTable
                    iconEdit={editar}
                    editarOnClick={() => openModal(row.original)}
                />
            ),
            resizable: false,
            accessor: "acoes",
            style: { width: 64 }
        });
    }
    return colunas;
}

function GerenciamentoProvas({
    ativar,
    subFuncionalidade: {
        url,
        tipoatividade,
        descricao
    },
}) {
    const [periodosLetivosOptions, setPeriodoLetivoOptions] = useState([]);
    const [semestresOptions, setSemestreOptions] = useState([]);
    const [modulosOptions, setModulosOptions] = useState([]);
    const [turmasOptions, setTurmasOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);

    const [periodoLetivoValue, setPeriodoLetivoValue] = useState();
    const [semestreValue, setSemestreValue] = useState();
    const [moduloValue, setModuloValue] = useState();
    const [turmaValue, setTurmaValue] = useState();
    const [statusValue, setStatusValue] = useState();

    const [dataInicio, setDataInicio] = useState();
    const [dataFim, setDataFim] = useState();

    const [dados, setDados] = useState([]);
    const [dadosModal, setDadosModal] = useState([]);

    const [modalGerenciamentoProva, setModalGerenciamentoProva] = useState(false);

    const acoes = {
        "criar": true,
        "editar": true,
        "deletar": true
    }

    const loadOptions = async () => {
        const response = await axiosApi.get(`filtros-gerenciamento-provas`);
        setPeriodoLetivoOptions(response.data.filtros.periodos_letivos.map(element => ({ label: element.descricao, value: element.id })));
        setSemestreOptions(response.data.filtros.semestres.map(element => ({ label: element.descricao, value: element.id })));
        setStatusOptions(
            response.data.filtros.status
                .filter(element => element.id !== 5)
                .map(element => ({ label: element.descricao, value: element.id }))
        );
        setModulosOptions([
            { label: 'Todos', value: '0' },
            ...response.data.filtros.modulos.map(element => ({ label: element.nome, value: element.id }))
        ]);
    }

    const limparFiltro = () => {
        setPeriodoLetivoValue('');
        setSemestreValue('');
        setModuloValue('');
        setTurmaValue('');
        setStatusValue('');
        setDataInicio(undefined);
        setDataFim(undefined);
        setDados([]);
        setTurmasOptions(undefined);
    }

    const getDadosFiltrados = async () => {
        const params = new URLSearchParams({
            semestre_id: semestreValue.value,
            periodo_letivo_id: periodoLetivoValue.value,
            // turma_id: turmaValue.value,
        });

        if (moduloValue?.value !== undefined)
            params.append('modulo_id', moduloValue.value);

        if (dataInicio !== undefined)
            params.append('data_inicio', dataInicio);

        if (dataFim !== undefined)
            params.append('data_fim', dataFim);

        if (statusValue?.value !== undefined)
            params.append('status_id', statusValue.value);

        const response = await axiosApi.get(`gerenciamento-prova?${params.toString()}`);
        setDados(response.data)
    }

    useEffect(() => {
        loadOptions();
    }, []);

    const onChangeSelect = (nome, valor) => {
        switch (nome) {
            case 'periodo_letivo_id':
                let periodoLetivo = periodosLetivosOptions.find((element) => element.value === valor);
                setPeriodoLetivoValue(periodoLetivo)
                break;
            case 'modulo_id':
                let modulo = modulosOptions.find((element) => element.value === valor);
                setModuloValue(modulo)
                break;
            case 'semestres_ids':
                let semestre = semestresOptions.find((element) => element.value === valor);
                setTurmaValue('')
                // getTurmas(valor);
                setSemestreValue(semestre);
                break;
            // case 'turma_id':
            //     let turma = turmasOptions.find((element) => element.value === valor);
            //     setTurmaValue(turma);
            //     break;
            case 'status_id':
                let status = statusOptions.find((element) => element.value === valor);
                setStatusValue(status);
                break;
            default:
                break;
        }
    }

    // const getTurmas = async (semestreId) => {
    //     const { data } = await axiosApi.get(`/auxiliares/turmas-semestre?semestre_id=${semestreId}&periodo_letivo_id=${periodoLetivoValue.value}`);
    //     setTurmasOptions(data.map(element => ({ label: element.descricao, value: element.id })));
    // }

    const openModal = (value) => {
        setDadosModal(value)
        setModalGerenciamentoProva(true);
    }

    const closeModal = () => {
        setDadosModal([])
        setModalGerenciamentoProva(false);
    }

    const onChangeHorario = (intervalo, valores) => {
        if (valores.from != undefined)
            setDataInicio(valores.from)
        if (valores.to != undefined)
            setDataFim(valores.to)
    };

    const colunas = React.useMemo(() => montarColunas(acoes, openModal), [dados])

    return (
        <Fragment>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} className="d-flex mb-3 header-legenda text-header">
                <h3><strong> {descricao.toUpperCase()} </strong></h3>
            </Col>
            <Col sm={12} md={12}>
                <Row className="pr-5 px-3">
                    <SelectForm
                        label="Período Letivo*"
                        name="periodo_letivo_id"
                        placeholder="Período Letivo"
                        options={periodosLetivosOptions}
                        value={periodoLetivoValue ?? ''}
                        onChange={onChangeSelect}
                        style={
                            {
                                col: {
                                    sm: 2,
                                    xs: 2,
                                    md: 2,
                                    lg: 2,
                                    xl: 2
                                }

                            }}
                    />
                    <SelectForm
                        readOnly={(periodoLetivoValue == undefined || periodoLetivoValue == "") ? true : false}
                        telaAgenda={true}
                        label="Semestre*"
                        name="semestres_ids"
                        value={semestreValue}
                        options={semestresOptions}
                        onChange={onChangeSelect}
                        placeholder="Semestre"
                        style={
                            {
                                col: {
                                    sm: 2,
                                    xs: 1,
                                    md: 1,
                                    lg: 1,
                                    xl: 1
                                }

                            }}
                    />
                    {/* <SelectForm
                        readOnly={(semestreValue !== undefined && semestreValue !== "") && (periodoLetivoValue !== undefined && periodoLetivoValue !== "") ? false : true}
                        telaAgenda={true}
                        label="Turma*"
                        name="turma_id"
                        value={turmaValue}
                        options={turmasOptions}
                        onChange={onChangeSelect}
                        placeholder="Turma"
                        style={
                            {
                                col: {
                                    sm: 1,
                                    xs: 2,
                                    md: 2,
                                    lg: 2,
                                    xl: 2
                                }

                            }}
                    /> */}
                    <SelectForm
                        label="Módulo"
                        name="modulo_id"
                        options={modulosOptions}
                        onChange={onChangeSelect}
                        value={moduloValue ?? ''}
                        placeholder="Módulo"
                        style={
                            {
                                col: {
                                    sm: 1,
                                    xs: 2,
                                    md: 2,
                                    lg: 2,
                                    xl: 2
                                }

                            }}
                    />
                    <SelectForm
                        label="Status"
                        name="status_id"
                        options={statusOptions}
                        onChange={onChangeSelect}
                        value={statusValue ?? ''}
                        placeholder="Status"
                        style={
                            {
                                col: {
                                    sm: 1,
                                    xs: 2,
                                    md: 2,
                                    lg: 2,
                                    xl: 2
                                }

                            }}
                    />

                    <DateForm
                        className="gerenciamento-provas"
                        name="intervalo_data"
                        label="Tipo de Marcador"
                        style={{ labelClass: "label-centralizado", telaAgenda: false, telaAvaliacao: true }}
                        onChange={onChangeHorario}
                        dataInicial={{ "label": "Data Inicial", ...dateInicialFormStyle, diasFuturos: true }}
                        dataFinal={{ "label": "Data Final", ...dateFinalFormStyle, diasFuturos: true }}
                        valorInicial={dataInicio}
                        valorFim={dataFim}
                        value={{ from: parseDate(dataInicio, formatLaravelDate), to: parseDate(dataFim, formatLaravelDate) }}
                    />
                    <Col className="btn-limpar-filtro-agenda">
                        <Button
                            className="mx-3 py-2 pesquisar-agenda"
                            onClick={getDadosFiltrados}
                        >Pesquisar</Button>
                    </Col>
                    <Col className="btn-limpar-filtro-agenda">
                        <Button
                            className="mx-3 py-2 pesquisar-agenda"
                            onClick={limparFiltro}
                        >Limpar</Button>
                    </Col>
                </Row>
            </Col>

            <ModalGerenciamentoProva
                isOpen={modalGerenciamentoProva}
                dadosModal={dadosModal}
                ativar={ativar}
                openModal={closeModal}
                setDadosGerenciamento={setDados}
            />

            <Col xs={13} sm={13} md={13} lg={13} xl={13} className={'pr-5 tabela-avaliacao-analitica'}>
                <Tabela
                    columns={colunas}
                    data={dados}
                    descricaoConteudo={true}
                />
            </Col>
        </Fragment>
    );
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        atualizarDadosRemotamente: (params) => dispatch(actionsRedux.atualizarSubFuncionalidade(ownProps.funcionalidade, ownProps.indiceSubFuncionalidade, params)),
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
    }
}

const mapStateToProps = (state) => {
    return {
        estruturaModal: state.subFuncionalidades.estruturaModal,
        estadoModal: state.subFuncionalidades.estadoModal,
        exibirCalendario: state.exibirCalendario ?? false
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardHoc(GerenciamentoProvas))

const dateInicialFormStyle = {
    "placeholder": "Data Inicial",
    "style": {
        "labelClass": "label-conteudoInferior",
        "elementoClass": "",
        "col": {
            "sm": 1
        }
    }
}
const dateFinalFormStyle = {
    "placeholder": "Data Final",
    "style": {
        "labelClass": "label-conteudoInferior",
        "elementoClass": "",
        "col": {
            "sm": 1
        }
    }
}